import { PHONE_NUMBER_REGEX } from 'src/constants';
import * as yup from 'yup';

export const bookingFormScheme = yup.object().shape({
  firstName: yup.string().required('Required'),
  lastName: yup.string().required('Required'),
  phoneNumber: yup.string().matches(PHONE_NUMBER_REGEX, 'Invalid phone number').required('Required'),
  email: yup.string().email().required('Required'),
  status: yup.string().required('Required'),
  price: yup.string().required('Required'),
  itemDescription: yup.string().required('Required'),
  dateTime: yup.string().required('Required'),
  peopleInVan: yup.string().required('Required'),
  rating: yup.number().min(0).max(5),
  lessThanThreeItems: yup.string().required('Required'),
});

export const settingFormScheme = yup.object().shape({
  noOfFreeMiles: yup.number().min(0).required('Required'),
  priceOfBaseCharge: yup.number().min(0).required('Required'),
  priceOfPerMile: yup.number().min(0).required('Required'),
  acceptMarketing: yup.number().min(0).max(100).required('Required'),
  extraStopCharge: yup.number().min(0).required('Required'),
  bookingFormStep1: yup.string().required('Required'),
  bookingFormStep2: yup.string().required('Required'),
  bookingFormStep3: yup.string().required('Required'),
  bookingFormStep4: yup.string().required('Required'),
  threeItems: yup.number().min(0).max(100).required('Required'),
  jobPercentage: yup.number().min(0).max(100).required('Required'),

  //extra clean
  // proIndoorDeepClean: yup.number().min(0).required('Required'),
  // surfaceAndCarpets: yup.number().min(0).required('Required'),
  // proGardenRefresh: yup.number().min(0).required('Required'),
  // proOvenClean: yup.number().min(0).required('Required'),
  // proExternalWindowClean: yup.number().min(0).required('Required'),
});
